import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import Dimmer from "semantic-ui-react/dist/es/modules/Dimmer";
import Loader from "semantic-ui-react/dist/es/elements/Loader";
import NavbarContainer from "../../Navbar/NavbarContainer";
import DataIcon from "../../../assets/svg/querybuilder.svg";
import { twitterAuthenticate } from "../../../actions/tokensAction";
import { Redirect } from "react-router-dom";
import { toast } from "react-toastify";
import "./SMROauth.scss";

function SMROauth(props) {
    const [authFailed, setAuthFailed] = useState(false);

    useEffect(() => {
        if (window.location.href.indexOf("?oauth_token=") > 0 || window.location.href.indexOf("?oauth_verifier=") > 0) {
            const url = window.location;
            console.log("first", url);
            const oAuthToken = new URLSearchParams(url.search).get("oauth_token");
            const oAuthVerifier = new URLSearchParams(url.search).get("oauth_verifier");
            const param = {};
            param["oauth_token"] = oAuthToken;
            param["oauth_verifier"] = oAuthVerifier;
            props.twitterAuthenticate(param);
        }

        if (window.location.href.indexOf("?error") > 0) {
            setAuthFailed(!authFailed);
            toast.error("Your authorization is failed");
        }
    }, []);

    return (
        <div className="smeOAuth">
            <NavbarContainer history={props.history} location={props.location} pageTitle="Twitter OAuth" icon={DataIcon} />
            <div className="smeOAuth__main">
                <div className="page__text">Authenticating</div>
                <div className="list-loading">
                    <Dimmer inverted active>
                        <Loader size="big" className="skiptranslate">
                            Loading
                        </Loader>
                    </Dimmer>
                </div>
            </div>
            {props.twitterLoginStatus && toast.success("Authentication successful") && (
                <Redirect
                    to={
                        window.location.href.includes("oauth-settings/accounts")
                            ? "/social-media-publishing/settings/accounts"
                            : window.location.href.includes("oauth-callback/inbox")
                            ? "/social-response/inbox"
                            : "/social-response/settings/accounts"
                    }
                />
            )}
            {props.twitterAuthenticationFailed && (
                <Redirect
                    to={
                        window.location.href.includes("oauth-settings/accounts")
                            ? "/social-media-publishing/settings/accounts"
                            : window.location.href.includes("oauth-callback/inbox")
                            ? "/social-response/inbox"
                            : "/social-response/settings/accounts"
                    }
                />
            )}
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        twitterLoginStatus: state.tokensReducer.twitterLoginStatus,
        twitterAuthenticationFailed: state.tokensReducer.twitterAuthenticationFailed,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        twitterAuthenticate: (data) => dispatch(twitterAuthenticate(data)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SMROauth);
